module.exports = __webpack_public_path__ + "img/cards.4124232b.png";